import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateProductPayload = {
  name?: string;
  image?: string | null;
  id: string;
};
type UpdateProductResponse = any;

export const updateProduct = async (
  payload: UpdateProductPayload
): Promise<UpdateProductResponse> => {
  try {
    const body = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => key !== 'id' && value !== undefined
      )
    );

    const { data } = await apiService.patch<UpdateProductResponse>(
      `/products/${payload.id}`,
      body
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
